// Gemeinsame Typen für Server und Web. Diese Datei gehört dem Kern (Verwaltungs-Tab).
// Teilsysteme legen ihre eigenen Typen in shared/src/module/<bereich>.ts ab.
/** Alle Bereiche (Teilsysteme) eines Projekts. Rechte werden pro Bereich vergeben. */
export const BEREICHE = ['mindmap', 'aufgaben', 'whiteboard', 'budget', 'mail', 'ideen', 'ki'];
export const BEREICH_NAMEN = {
    mindmap: 'Mindmap',
    aufgaben: 'Aufgaben',
    whiteboard: 'Whiteboard',
    budget: 'Budget',
    mail: 'Mail',
    ideen: 'Ideen',
    ki: 'KI-Hilfe',
};
export function istBereich(x) {
    return typeof x === 'string' && BEREICHE.includes(x);
}
/** Zugriffsstufe pro Bereich: kein Zugriff, nur sehen, sehen und ändern. */
export const STUFEN = ['kein', 'lesen', 'schreiben'];
export function stufeMindestens(hat, braucht) {
    return STUFEN.indexOf(hat) >= STUFEN.indexOf(braucht);
}
/** Rolle im Projekt. Leitung verwaltet Mitglieder und Rechte. */
export const ROLLEN = ['leitung', 'mitglied', 'gast'];
export const ROLLEN_NAMEN = {
    leitung: 'Leitung',
    mitglied: 'Mitglied',
    gast: 'Gast',
};
/** Standardstufe je Rolle, bevor Einzelrechte greifen. */
export const ROLLEN_STANDARD = {
    leitung: 'schreiben',
    mitglied: 'schreiben',
    gast: 'lesen',
};
/** Welche KI ein Projekt nutzt. 'lokal' = Ollama, 'claude' = Claude-API, 'aus' = keine KI. */
export const KI_ANBIETER = ['lokal', 'claude', 'aus'];
/**
 * Kanalnamen: p:<projektId>:<bereich>[:<unterkanal>]
 * Beispiel: p:6f1…:whiteboard:tafel-3
 */
export function kanal(projektId, bereich, unter) {
    return unter ? `p:${projektId}:${bereich}:${unter}` : `p:${projektId}:${bereich}`;
}
export function kanalZerlegen(k) {
    const teile = k.split(':');
    if (teile.length < 3 || teile[0] !== 'p')
        return null;
    const [, projektId, bereich, ...rest] = teile;
    if (!projektId || !istBereich(bereich))
        return null;
    return { projektId, bereich, unter: rest.length ? rest.join(':') : null };
}
//# sourceMappingURL=index.js.map